import { FormattedIdentityProviderDetails } from "@idw-types/data/identity-providers";
import { IdentityProviderDetailsReferenceData } from "@idw-types/state/identity-provider-details-state";

export enum IdentityProviderDetailsActionTypes {
    SET_IDENTITY_PROVIDER_DETAILS_LOADING = "SET_IDENTITY_PROVIDER_DETAILS_LOADING",
    SET_IDENTITY_PROVIDER_DETAILS = "SET_IDENTITY_PROVIDER_DETAILS",
    SET_IDENTITY_PROVIDER_DETAILS_REFERENCE_DATA_LOADING = "SET_IDENTITY_PROVIDER_DETAILS_REFERENCE_DATA_LOADING",
    SET_IDENTITY_PROVIDER_DETAILS_REFERENCE_DATA = "SET_IDENTITY_PROVIDER_DETAILS_REFERENCE_DATA"
}

//DETAILS
type SetIdentityProviderDetailsLoadingAction = {
    type: IdentityProviderDetailsActionTypes.SET_IDENTITY_PROVIDER_DETAILS_LOADING,
    payload: { isLoading: boolean; }
};

export const setIdentityProviderDetailsLoading = (isLoading: boolean): SetIdentityProviderDetailsLoadingAction => ({
    type: IdentityProviderDetailsActionTypes.SET_IDENTITY_PROVIDER_DETAILS_LOADING,
    payload: { isLoading }
});

type SetIdentityProviderDetailsAction = {
    type: IdentityProviderDetailsActionTypes.SET_IDENTITY_PROVIDER_DETAILS,
    payload: { identityProviderDetails: FormattedIdentityProviderDetails; }
}

export const setIdentityProviderDetails = (identityProviderDetails: FormattedIdentityProviderDetails): SetIdentityProviderDetailsAction => ({
    type: IdentityProviderDetailsActionTypes.SET_IDENTITY_PROVIDER_DETAILS,
    payload: { identityProviderDetails }
});

type SetIdentityProviderDetailsReferenceDataLoading = {
    type: IdentityProviderDetailsActionTypes.SET_IDENTITY_PROVIDER_DETAILS_REFERENCE_DATA_LOADING,
    payload: { isLoading: boolean; }
};

export const setIdentityProviderDetailsReferenceDataLoading = (isLoading: boolean): SetIdentityProviderDetailsReferenceDataLoading => ({
    type: IdentityProviderDetailsActionTypes.SET_IDENTITY_PROVIDER_DETAILS_REFERENCE_DATA_LOADING,
    payload: { isLoading }
});

type SetIdentityProviderDetailsReferenceData = {
    type: IdentityProviderDetailsActionTypes.SET_IDENTITY_PROVIDER_DETAILS_REFERENCE_DATA,
    payload: { referenceData: IdentityProviderDetailsReferenceData; }
};

export const setIdentityProviderDetailsReferenceData = (referenceData: IdentityProviderDetailsReferenceData): SetIdentityProviderDetailsReferenceData => ({
    type: IdentityProviderDetailsActionTypes.SET_IDENTITY_PROVIDER_DETAILS_REFERENCE_DATA,
    payload: { referenceData }
});

export type IdentityProviderDetailsActions =
    SetIdentityProviderDetailsLoadingAction |
    SetIdentityProviderDetailsAction |
    SetIdentityProviderDetailsReferenceDataLoading |
    SetIdentityProviderDetailsReferenceData